// removed by extract-text-webpack-plugin
module.exports = {"fullscreen":"_3NpD8310oFHg22_GrJkwfc","first":"_91b3u5yTpnSfUw-7W5VnL _3NpD8310oFHg22_GrJkwfc"};


//////////////////
// WEBPACK FOOTER
// ../components/fullscreen/styles.module.css
// module id = 397
// module chunks = 0